import React, { Component, useState, useEffect } from 'react';
import { component } from 'picoapp';
import { createRoot } from 'react-dom/client';
import ReactPlayer from 'react-player';

class PlayIcon extends Component {
  render() {
    return (
      <button className="Button Button--play" data-style="noLayout" aria-label="play">
        <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
          <use href="#play"></use>
        </svg>
      </button>
    )
  }
}

const MediaPlayer = ({ ctx, el }) => {
  const [videoLink, setVideoLink] = useState(el.dataset.videoUrl)
  const [cover, setCover] = useState(el.dataset.cover)
  const [lightMode, setLightMode] = useState(false)
  const [playing, setPlaying] = useState(false)
  const [muted, setMuted] = useState(false)

  useEffect(() => {

    if (Object.keys(el.dataset).includes("lightMode")) {
      setLightMode(true)
    }

    const parentController = el.closest('.js-videoController');
    if (parentController) {
      parentController.addEventListener('isActive', start);
      parentController.addEventListener('isInactive', pause);
    }
  }, [])

  useEffect(() => {
    if (playing) {
      setLightMode(false)
    }
  }, [playing])

  const start = () => {
    setPlaying(true)
  }

  const pause = () => {
    setPlaying(false)
  }

  return (
    <ReactPlayer
      className="media-player"
      url={videoLink}
      playing={playing}
      muted={muted}
      width="100%"
      height="100%"
      light={cover ? cover : lightMode}
      playIcon={<PlayIcon />}
      onClickPreview={() => setPlaying(true)}
      controls={true}
      playsinline={true}
      config={{
        youtube: {
          playerVars: {
            modestbranding: 1,
            showinfo: 0
          }
        }
      }}
    />
  );
}

export default component((node, ctx) => {
  if (!customElements.get('media-player')) {
    customElements.define(
      'media-player',
      class extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          const element = <MediaPlayer ctx={ctx} el={this} />;
          const root = createRoot(this);
          root.render(element);
        }
      }
    );
  }
});